/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Last_UpdatedInputs */

const en_privacy_last_updated = /** @type {(inputs: Privacy_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last updated: August 24, 2026`)
};

const lv_privacy_last_updated = /** @type {(inputs: Privacy_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pēdējoreiz atjaunināts: 2026. gada 24. augusts`)
};

/**
* | output |
* | --- |
* | "Last updated: August 24, 2026" |
*
* @param {Privacy_Last_UpdatedInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_last_updated = /** @type {((inputs?: Privacy_Last_UpdatedInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Last_UpdatedInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_last_updated(inputs)
	return en_privacy_last_updated(inputs)
});